/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationType } from '../models/ApplicationType';
import type { JobProgramChooserRequest } from '../models/JobProgramChooserRequest';
import type { ProgramResponse } from '../models/ProgramResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class JobProgramRoutesRepository {
  /**
   * Job Programs Chooser
   * API to choose which job-programs to opt into or out of for a job.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobProgramRoutesJobProgramsChooser({
    jobId,
    requestBody,
    authorization,
  }: {
    jobId: any,
    requestBody: JobProgramChooserRequest,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/job-programs-chooser',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Additional Programs Available
   * API to choose which job-programs to opt into or out of for a job.
   * @returns ProgramResponse Successful Response
   * @throws ApiError
   */
  public static jobProgramRoutesAdditionalProgramsAvailable({
    jobId,
    authorization,
  }: {
    jobId: any,
    authorization?: string,
  }): CancelablePromise<Array<ProgramResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/jobs/{job_id}/additional-programs',
      path: {
        'job_id': jobId,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Application Type
   * Assign job program application type.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static jobProgramRoutesUpdateApplicationType({
    jobId,
    jobProgramId,
    applicationType,
    authorization,
  }: {
    jobId: string,
    jobProgramId: string,
    applicationType: ApplicationType,
    authorization?: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/jobs/{job_id}/job-programs/{job_program_id}/application-type',
      path: {
        'job_id': jobId,
        'job_program_id': jobProgramId,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'application_type': applicationType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
